<div class="div-slider-button">
  <label class="div-slider" #divSlider>
    <input type="checkbox" (change)="onOroffToggle()" id="slideract" #silder/>
    <div class="div-circle-slider div-circle-sliderr" #circleSlid></div>
  </label>
  <p class="text-word" #isPreference>{{defaultPreference}}</p>
</div>
